import React from 'react'
import styled from 'styled-components'
import { Redirect } from 'react-router'

import { typography, utils, flex, breakpoints } from '../styles'
import { episodes } from '../data'
import BannerNav from './BannerNav'
import Cta from './Cta'
import EpisodeSummary from './EpisodeSummary'
import NavLink from './NavLink'
import Testimonials from './Testimonials'
import HR from './HR'
import Head from './Head'

const Section = styled.section`
  padding: 1rem;
  ${ utils.container }
`

const Body = styled.div`
  background: white;
  color: black;
  padding: 2rem 0;
`

const Nav = styled.div`
  padding-top: 4rem;
  ${ flex.wrap.centerBoth }
  ${ typography.lh14.center }
  > * {
    flex: 0 0 33%;
    padding: 0.5rem;
    ${ breakpoints.handheld`
      flex: 0 0 100%;
      &:nth-child(2) { order: 1; }
    ` }
  }
`

export default ({ params }) => {
  if (!/^\d+/.exec(params.episodeNr)) return <Redirect to="/"/>
  let episodeIndex = parseInt(params.episodeNr, 10) - 1
  const ep = episodes[episodeIndex]
  let prevEp = episodes[episodeIndex - 1]
  let nextEp = episodes[episodeIndex + 1]
  return <div>
    <Head title={`Front End Center – Episode ${episodeIndex + 1}: ${ep.title}` }
          image={ep.banner}
    />
    <BannerNav/>
    <Body>
      <Section>
        <EpisodeSummary ep={ep} expanded={true}/>
        <Cta analyticsLabel="abovetweets"/>
        <HR/>
        <Testimonials/>
        <HR/>
        <Cta analyticsLabel="belowtweets"/>
        <Nav>
          { prevEp && <div>
            Previous episode: <NavLink to={`/ep${prevEp.slug}`}>{ prevEp.title }</NavLink>
          </div> }
          <div>🎥<NavLink to="/">See all episodes</NavLink></div>
          { nextEp && <div>
            Next episode: <NavLink to={`/ep${nextEp.slug}`}>{ nextEp.title }</NavLink>
          </div> }
        </Nav>
      </Section>
    </Body>
  </div>
}



/** WEBPACK FOOTER **
 ** ./src/components/EpisodePage.js
 **/